import { useCallback } from "react";
import AccountMpProvider from "@/core/data-provider/data-mp/account/account-mp-provider";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import { setUser } from "@/domains/account/slice";

export default function useGetUser() {
  const dispatch = useAppDispatch();

  const getUser = useCallback(async () => {
    const response = await AccountMpProvider.getUser();
    if (response instanceof RpcMpProviderSuccessResponse) {
      dispatch(setUser(response.data));
    }
  }, [dispatch]);

  return { getUser };
}
